import { createSlice } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: Array<{
    label: string;
    value: string;
  }>;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,

  data: [],
};

const getListRecruitmentPositionSlice = createSlice({
  name: "getListRecruitmentPosition",
  initialState,
  reducers: {
    getListRecruitmentPositionStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getListRecruitmentPositionSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = [...state.data, ...action.payload];
    },
    getListRecruitmentPositionFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },

    resetListRecruitmentPosition: (state) => {
      state.data = [];
      state.status = ReduxStateType.INIT;
    },
  },
});

export const {
  getListRecruitmentPositionStart,
  getListRecruitmentPositionSuccess,
  getListRecruitmentPositionFailed,
  resetListRecruitmentPosition,
} = getListRecruitmentPositionSlice.actions;

export default getListRecruitmentPositionSlice.reducer;
